import { appEventModule } from "app/event"
import { setCurrentLocaleFromContext } from "./tools/common"

export function startLanguageListeners(): void {
  appEventModule.on.storeReady("language-store-ready", () => {
    appEventModule.remove("language-store-ready")
    setCurrentLocaleFromContext()
  })
}
